import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=3f4b980a&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&id=3f4b980a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b980a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4b980a')) {
      api.createRecord('3f4b980a', component.options)
    } else {
      api.reload('3f4b980a', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=3f4b980a&scoped=true&", function () {
      api.rerender('3f4b980a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/Company.vue"
export default component.exports